import { Type } from 'class-transformer';
import {
  IFormResponse,
  IFormResponseCustomer,
  IFormResponseFormType
} from '../interfaces/form-response.interface';

export class FormResponseDto implements IFormResponse {
  id!: string;

  code!: string;

  status!: string;

  @Type(() => Date)
  creationDate!: Date;

  @Type(() => Date)
  finishDate?: Date;

  time!: number;

  customer!: IFormResponseCustomer;

  formType!: IFormResponseFormType;
}
